import Loading from '../../../../Dashboards/Common/Loading';
import { AnnualEvolutionRegisters } from './AnnualEvolutionRegisters';
import { MonthlyEvolutionRegistersPercentage } from './MonthlyEvolutionRegistersPercentage';
import { MonthlyEvolutionRelationIndividualAndhouseHold } from './MonthlyEvolutionRelationIndividualAndhouseHold';
import { TableHouseHoldAndIndividualRegister } from './TableHouseHoldAndIndividualRegister';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const Charts = () => {
    const { isLoading } = useResultsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionRegisters />
                <MonthlyEvolutionRegistersPercentage />
            </div>
            <div className="charts-side-by-side-dashboards">
                <MonthlyEvolutionRelationIndividualAndhouseHold />
                <TableHouseHoldAndIndividualRegister />
            </div>
        </>
    );
};
